module.exports = __webpack_public_path__ + "img/Draco.ff38b809.png";